// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'header';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.656 1.368h14.616c.648 0 1.152.504 1.152 1.152v13.104c0 .648-.504 1.152-1.152 1.152H1.656a1.137 1.137 0 0 1-1.152-1.152V2.52c.072-.648.576-1.152 1.152-1.152zM.576 5.904h16.848'
  />
);

export const viewBox = '0 0 18 18';
